function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { connectControllerToDiscountTextField } from "../../../utils/react-hook-form.utils";
import DiscountTextField from "../../DiscountTextField";
import Decimal from 'decimal.js';
import { utils } from "../../../utils";
import { DiscountType } from "../../../models/service/model";
export default function DiscountInput() {
  const {
    control,
    watch,
    trigger,
    getValues
  } = useFormContext();
  const [pricing, price, minPrice] = watch(['pricing', 'price', 'minPrice']);
  useEffect(() => {
    trigger('discount');
  }, [pricing, price, minPrice]);
  return /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "discount",
    rules: {
      validate: _ref => {
        let {
          type,
          amount
        } = _ref;
        const errorMsg = 'Wrong amount';
        const {
          pricing,
          price,
          minPrice
        } = getValues();

        if (price && utils.applyDiscount(new Decimal(+price), {
          type,
          amount: new Decimal(+amount)
        }).lessThan(0)) {
          return errorMsg;
        }

        if (pricing === 'range' && minPrice && utils.applyDiscount(new Decimal(+minPrice), {
          type,
          amount: new Decimal(+amount)
        }).lessThan(0)) {
          return errorMsg;
        }
      }
    },
    render: p => {
      const {
        discount: {
          type
        }
      } = getValues();
      return /*#__PURE__*/React.createElement(DiscountTextField, _extends({
        alwaysShrinkLabel: true,
        label: type === DiscountType.Percent ? 'Discount' : 'Unit discount',
        "data-testid": "sb-discount"
      }, connectControllerToDiscountTextField(p)));
    }
  });
}